import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ThankYou = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f9fafb",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          p: 5,
          borderRadius: 4,
          backgroundColor: "#fff",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
        }}
      >
        <CheckCircleIcon
          sx={{
            fontSize: 80,
            color: "#2e7d32", // green
            mb: 2,
          }}
        />

        <Typography variant="h4" fontWeight={600} gutterBottom>
          Thank You
        </Typography>

        <Typography variant="body1" color="text.secondary">
          Your details have been submitted successfully. You can close this tab now.
        </Typography>
      </Box>
    </Box>
  );
};

export default ThankYou;
